<div class="text-page-text min-h-[100vh] flex flex-col">
  <app-header />

  <div class="grow relative">
    <router-outlet />
  </div>

  <app-footer />
</div>
